export default {
  SIGN_UP_PAGE_SIGN_UP: 'SIGN_UP_PAGE_SIGN_UP',
  SIGN_UP_PAGE_UPDATE_FORM: 'SIGN_UP_PAGE_UPDATE_FORM',
  SIGN_UP_PAGE_INVALID_FORM: 'SIGN_UP_PAGE_INVALID_FORM',
  SIGN_UP_PAGE_VALID_FORM: 'SIGN_UP_PAGE_VALID_FORM',
  SIGN_UP_PAGE_FORM_REQUEST_SUBMITTED: 'SIGN_UP_PAGE_FORM_REQUEST_SUBMITTED',
  SIGN_UP_PAGE_FORM_REQUEST_COMPLETE: 'SIGN_UP_PAGE_FORM_REQUEST_COMPLETE',
};